import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { RoleAccessModel } from '../../../pages/role/shared/model';

@Injectable({
	providedIn: 'root',
})
export class RoleAccessService {
	private roleAccess = new BehaviorSubject<RoleAccessModel[]>(null);
	public roleAccess$ = this.roleAccess.asObservable();

	constructor() {}

	public setRoleAccess(access: RoleAccessModel[]) {
		this.roleAccess.next(access);
	}
}
